// import { AppConfiguration } from "config";
import Select from 'react-select';
import { AppConfiguration } from "config";
import * as Yup from "yup";
import React, { useEffect } from "react";
import { MetaTags } from "react-meta-tags";
import { Button, Col, Container, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { methodsOfQuestions, optionsPersonalInformation, receiveInfoVia } from 'helpers/sf_lead_constants';
import { useFormik } from 'formik';
import * as CONSTANTS from "../../common/utils/data_validations"
import NumberFormat from 'react-number-format';
import { us_states } from 'common/data/us_states';
import { useDispatch, useSelector } from 'react-redux';
import { createCCPARequest, resetToastMessage } from 'store/quotes_funnel_ccpa/actions';
import ToastAlert, { ToastAlertIconType } from 'components/Common/ToastAlert/ToastAlert';


const CCPAPolicyQf = () => {
    const dispatch = useDispatch();

    const { toastMessage } = useSelector(state => ({
        toastMessage: state.QuoteFunnelsCCPA.toastMessage,
    }));

    let state_names = []
    us_states.map(e => {
        state_names.push({ label: e.isocode, value: e.name })
      })

    const optionGroupStates = [
        {
          label: "Select State",
          options: state_names,
        },
      ]
    
    useEffect(() => {
        if (toastMessage) {
            ToastAlert.fire({ icon: ToastAlertIconType.OK, title: "Request submission successful", timer: 5000});
            dispatch(resetToastMessage())
        }
    }, [toastMessage])


    const validation = useFormik({
        enableReinitialize: false,
        initialValues: {
            first_name: '',
            last_name: '',
            address: '',
            city: '',
            state: '',
            zip_code: '',
            email: '',
            phone_num: '',
            agent_first_name: '',
            agent_last_name: '',
            agent_email: '',
            agent_phone: '',
            preferred_method_for_questions: '',
            receive_information_via: '',

            access_personal_information: false,
            type_of_info_like_to_receive: '',
            personal_information_souces_type: true,
            business_purpose_type: true,
            third_parties_information: true,
            business_purposes_for_disclose: true,

            delete_personal_info: false,
            opt_out_of_sale: false,
            authorized_agent: false
        },
        validationSchema: Yup.object({
            first_name: Yup.string()
                .required(CONSTANTS.STR_REQUIRED_FIRSTNAME)
                .matches(
                    CONSTANTS.nameRegExp,
                    CONSTANTS.STR_INVALID_FIRST_NAME)
                .min(2),
            last_name: Yup.string()
                .required(CONSTANTS.STR_REQUIRED_LASTNAME)
                .matches(
                    CONSTANTS.nameRegExp,
                    CONSTANTS.STR_INVALID_LAST_NAME
                )
                .min(2),
            address: Yup.string()
                .required(CONSTANTS.STR_REQUIRED_ADDRESS)
                .min(3)
                .matches(
                    CONSTANTS.addressRegExp,
                    CONSTANTS.STR_INVALID_ADDRESS
            ),
            city: Yup.string()
                .required(CONSTANTS.STR_REQUIRED_CITY)
                .matches(
                    CONSTANTS.cityRegExp,
                    CONSTANTS.STR_INVALID_CITY
                )
                .min(2),
            state: Yup.object().shape({
                label: Yup.string().required(),
                value: Yup.string().required(),
            }),
            zip_code: Yup.string()
                .required(CONSTANTS.STR_REQUIRED_ZIP)
                .matches(CONSTANTS.zipcodeRegExp, "Please enter a valid zip code"),
            email: Yup.string()
                .email()
                .required(CONSTANTS.STR_REQUIRED_FIELD)
                .test(
                    "Validate Email",
                    CONSTANTS.STR_INVALID_EMAIL,
                    function (value) {
                        if (value) {
                            if (CONSTANTS.invalidEmailRegex.test(value)) {
                                return this.createError({
                                    message: CONSTANTS.STR_INVALID_EMAIL_DIGITS_ERROR,
                                });
                            }
                        }
                        return true;
                    },
                ),
            phone_num: Yup.string()
            .matches(
                CONSTANTS.phoneRegExp,
                CONSTANTS.STR_INVALID_PHONE_NUMBER
                )
                .required(CONSTANTS.STR_REQUIRED_PHONE_NUMBER),
            authorized_agent: Yup.boolean(),
            agent_first_name: Yup.string()
                .when('authorized_agent', {
                    is: true, // only apply validation if authorized_agent is true
                    then: Yup.string()
                        .required(CONSTANTS.STR_REQUIRED_FIELD)
                        .matches(
                            CONSTANTS.nameRegExp,
                            CONSTANTS.STR_INVALID_FIRST_NAME)
                        .min(2),
                    otherwise: Yup.string().notRequired() // make it optional when authorized_agent is false
                }),
            agent_last_name: Yup.string()
                .when('authorized_agent', {
                    is: true,
                    then: Yup.string()
                        .required(CONSTANTS.STR_REQUIRED_FIELD)
                        .matches(
                            CONSTANTS.nameRegExp,
                            CONSTANTS.STR_INVALID_LAST_NAME
                        )
                        .min(2),
                    otherwise: Yup.string().notRequired()
                }),
            agent_email: Yup.string()
                .when('authorized_agent', {
                    is: true,
                    then: Yup.string()
                        .email()
                        .required(CONSTANTS.STR_INVALID_EMAIL),
                    otherwise: Yup.string().notRequired()
                }),
            agent_phone: Yup.string()
                .when('authorized_agent', {
                    is: true,
                    then: Yup.string()
                        .matches(
                            CONSTANTS.phoneRegExp,
                            CONSTANTS.STR_INVALID_PHONE_NUMBER
                        )
                        .required(CONSTANTS.STR_REQUIRED_FIELD),
                    otherwise: Yup.string().notRequired()
                }),
          }),
        onSubmit: (values) => {
            const submitValues = ({
                ...values,
                preferred_method_for_questions: values.preferred_method_for_questions.label, 
                receive_information_via: values.receive_information_via.label, 
                type_of_info_like_to_receive: values.type_of_info_like_to_receive.label, 
                state: values.state.label, 
                personal_information_souces_type: values?.access_personal_information === false ? false : values?.personal_information_souces_type,
                business_purpose_type: values?.access_personal_information === false ? false : values?.business_purpose_type,
                third_parties_information: values?.access_personal_information === false ? false : values?.third_parties_information,
                business_purposes_for_disclose: values?.access_personal_information === false ? false : values?.business_purposes_for_disclose,
            });
            dispatch(createCCPARequest(submitValues));
            validation.resetForm()
          },
    })


    return (
            <div className="page-content" style={{ padding: '0px' }}>
                <React.Fragment>
                        <MetaTags>
                            <title>California Privacy Rights | {AppConfiguration.WEBSITE}</title>
                        </MetaTags>
                        <Container className='my-5 px-4'>
                            <Row className='d-flex justify-content-center text-justify mb-3'>
                                <Col>
                                    <div style={{lineHeight: '1.7'}}>
                                        <>
                                            <h1 className="quote-funnel-answer-header text-black text-start">California Privacy Rights</h1>
                                            <p className="fs-16">Under the California Consumer Privacy Act (“CCPA”), California residents have the right to access, delete, and opt-out from the sale of their Personal Information.</p>
                                            <p className="fs-16">To file your CCPA request, please complete the form at the bottom of this page or call us at (877)-554-4461. On receipt of your request, we may request additional information if we are unable to verify your identity based on comparing the information you submit with information we retain in our files, or if we believe additional information is needed to verify your identity. If you request to receive the specific pieces of Personal Information in our files about you, we will send you and require you to return a signed declaration, under penalty of perjury, verifying your identity and request.</p>
                                            <p className="fs-16">If you file a request to access or delete your Personal Information, we have 45 days to respond to your request. We may also inform you that we need up to 45 additional days to respond and the reason we need additional time. If you opt-out of the sale of your Personal Information, we have 15 days to process your opt-out request.</p>
                                            <p className="fs-16">If you are an authorized agent of a requesting consumer, you must provide a written authorization from the consumer or a copy of a lawful power of attorney that permits you to submit the request on the consumer’s behalf. You may provide that written authorization to us via email at opt-out@insureo.co after submitting the request. We may contact you or the consumer on whose behalf you claim to act to verify your authorization.</p>
                                            <p className="fs-16">Additional information about how we collect, use, and disclose Personal Information, and methods by which you may contact us with questions, can be found in our Privacy Policy . You may find the answer you are looking for faster by reviewing the Privacy Policy than by submitting a request and waiting for our response.</p>
                                        </>
                                        <Form onSubmit={e => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false
                                        }}>
                                            <Row className='d-flex justify-content-center align-items-center'>
                                                {/* first_name starts */}
                                                <Col md='6' className='d-flex flex-column fs-16 align-self-center mb-2'>
                                                    <Label className="font-weight-semibold">First Name<span className="text-danger">*</span></Label>
                                                    <Input
                                                        id="first_name"
                                                        name="first_name"
                                                        type='text'
                                                        className='form-control form-control-lg text-capitalize'
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.first_name || ""}
                                                        invalid={
                                                        validation.touched.first_name && validation.errors.first_name
                                                            ? true
                                                            : false
                                                        }
                                                    />
                                                    {validation.touched.first_name && validation.errors.first_name ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.first_name}
                                                        </FormFeedback>
                                                    ) : null}
                                                </Col>
                                                {/* first_name ends */}
                                                {/* last_name starts */}
                                                <Col md='6' className='d-flex flex-column fs-16 align-self-center mb-2'>
                                                    <Label className="font-weight-semibold">Last Name<span className="text-danger">*</span></Label>
                                                    <Input
                                                        id="last_name"
                                                        name="last_name"
                                                        type='text'
                                                        className='form-control form-control-lg text-capitalize'
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.last_name || ""}
                                                        invalid={
                                                        validation.touched.last_name && validation.errors.last_name
                                                            ? true
                                                            : false
                                                        }
                                                    />
                                                    {validation.touched.last_name && validation.errors.last_name ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.last_name}
                                                        </FormFeedback>
                                                    ) : null}
                                                </Col>
                                                {/* last_name ends */}
                                                {/* address starts */}
                                                <Col md='12' className='d-flex flex-column fs-16 align-self-center mb-2'>
                                                    <Label className="font-weight-semibold">Address<span className="text-danger">*</span></Label>
                                                    <Input
                                                        id="address"
                                                        name="address"
                                                        type='text'
                                                        className='form-control form-control-lg text-capitalize'
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.address || ""}
                                                        invalid={
                                                        validation.touched.address && validation.errors.address
                                                            ? true
                                                            : false
                                                        }
                                                    />
                                                    {validation.touched.address && validation.errors.address ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.address}
                                                        </FormFeedback>
                                                    ) : null}
                                                </Col>
                                                {/* address ends */}
                                                {/* city starts */}
                                                <Col md='3' className='d-flex flex-column fs-16 align-self-center mb-2'>
                                                    <Label className="font-weight-semibold">City<span className="text-danger">*</span></Label>
                                                    <Input
                                                        id="city"
                                                        name="city"
                                                        type='text'
                                                        className='form-control form-control-lg text-capitalize'
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.city || ""}
                                                        invalid={
                                                        validation.touched.city && validation.errors.city
                                                            ? true
                                                            : false
                                                        }
                                                    />
                                                    {validation.touched.city && validation.errors.city ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.city}
                                                        </FormFeedback>
                                                    ) : null}
                                                </Col>
                                                {/* city ends */}
                                                {/* state starts */}
                                                <Col md='6' className='d-flex flex-column fs-16 align-self-center mb-2'>
                                                    <Label className="font-weight-semibold">State<span className="text-danger">*</span></Label>
                                                    <Select
                                                        options={optionGroupStates}
                                                        classNamePrefix="select2-selection"
                                                        onChange={selectedOption => {
                                                            let event = {
                                                            target: {
                                                                name: "state",
                                                                value: selectedOption,
                                                            },
                                                            }
                                                            validation.handleChange(event)
                                                        }}
                                                        onBlur={() => {
                                                            validation.handleBlur({
                                                            target: { name: "state" },
                                                            })
                                                        }}
                                                        value={validation.values.state || ""}
                                                        invalid={
                                                            validation.touched.state &&
                                                            validation.errors.state
                                                            ? true
                                                            : false
                                                        }
                                                        />
                                                        {validation.touched.state &&
                                                        validation.errors.state ? (
                                                        <small className="text-danger">
                                                            {CONSTANTS.STR_REQUIRED_STATE}
                                                        </small>
                                                        ) : null}
                                                </Col>
                                                {/* state ends */}
                                                {/* zip_code starts */}
                                                <Col md='3' className='d-flex flex-column fs-16 align-self-center mb-2'>
                                                    <Label className="font-weight-semibold">Zip<span className="text-danger">*</span></Label>
                                                    <Input
                                                        name="zip_code"
                                                        type="zip_code"
                                                        className='form-control form-control-lg text-capitalize'
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.zip_code || ""}
                                                        invalid={
                                                            validation.touched.zip_code &&
                                                            validation.errors.zip_code
                                                            ? true
                                                            : false
                                                        }
                                                        />
                                                        {validation.touched.zip_code &&
                                                        validation.errors.zip_code ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.zip_code}
                                                        </FormFeedback>
                                                        ) : null}
                                                </Col>
                                                {/* zip_code ends */}
                                                {/* email starts */}
                                                <Col md='6' className='d-flex flex-column fs-16 align-self-center mb-2'>
                                                    <Label className="font-weight-semibold">Email<span className="text-danger">*</span></Label>
                                                    <Input
                                                        id="email"
                                                        name="email"
                                                        type='text'
                                                        className='form-control form-control-lg'
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email || ""}
                                                        invalid={
                                                        validation.touched.email && validation.errors.email
                                                            ? true
                                                            : false
                                                        }
                                                    />
                                                    {validation.touched.email && validation.errors.email ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.email}
                                                        </FormFeedback>
                                                    ) : null}
                                                </Col>
                                                {/* email ends */}
                                                {/* phone_num starts */}
                                                <Col md='6' className='d-flex flex-column fs-16 align-self-center mb-2'>
                                                    <Label className="font-weight-semibold">Phone<span className="text-danger">*</span></Label>
                                                    <NumberFormat
                                                        name="phone_num"
                                                        format="###-###-####"
                                                        type="text"
                                                        mask="_"
                                                        className={validation.touched.phone_num && validation.errors.phone_num ? "is-invalid form-control form-control-lg" : "form-control form-control-lg"}
                                                        onValueChange={(values) => {
                                                            const { value } = values;
                                                            validation.setFieldValue('phone_num', value);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.phone_num || ""}
                                                        invalid={validation.touched.phone_num && validation.errors.phone_num ? "true" : "false"}
                                                        aria-invalid={validation.touched.phone_num && validation.errors.phone_num ? "true" : "false"}
                                                        />
                                                        {validation.touched.phone_num && validation.errors.phone_num ? (
                                                        <small className="text-danger">
                                                            {validation.errors.phone_num}
                                                        </small>
                                                        ) : null}
                                                </Col>
                                                {/* phone_num ends */}
                                                {/* preferred_method_for_questions starts */}
                                                <Row className="my-2 mt-4 px-0">
                                                    <Col md='6' sm='12' className='fs-16 mb-2 pe-2'>
                                                        <Label className="font-weight-semibold">What are your preferred contact methods for questions about your request?</Label>
                                                    </Col>
                                                    <Col md="6" sm='12'>
                                                        <Select
                                                            name="preferred_method_for_questions"
                                                            options={methodsOfQuestions}
                                                            // maxMenuHeight="200px"
                                                            classNamePrefix="select2-selection"
                                                            className="form-control-lg p-0"
                                                            placeholder=""
                                                            onChange={selectedOption => {
                                                                let event = {
                                                                  target: {
                                                                    name: "preferred_method_for_questions",
                                                                    value: selectedOption,
                                                                  },
                                                                }
                                                                validation.handleChange(event)
                                                              }}
                                                              onBlur={() => {
                                                                validation.handleBlur({
                                                                  target: { name: "preferred_method_for_questions" },
                                                                })
                                                              }}
                                                              value={validation.values.preferred_method_for_questions || ""}
                                                              invalid={
                                                                validation.touched.preferred_method_for_questions &&
                                                                  validation.errors.preferred_method_for_questions
                                                                  ? true
                                                                  : false
                                                              }
                                                            />
                                                            {validation.touched.preferred_method_for_questions
                                                              && validation.errors.preferred_method_for_questions ? (
                                                              <small className="text-danger fs-13">
                                                                {CONSTANTS.STR_REQUIRED_FIELD}
                                                              </small>
                                                            ) : null}
                                                    </Col>
                                                </Row>
                                                {/* preferred_method_for_questions ends */}
                                                {/* receiveInfoVia starts */}
                                                <Row className="my-2 mt-2 px-0">
                                                    <Col md='6' className='fs-16 mb-2'>
                                                        <Label className="font-weight-semibold">How do you want to receive the information you requested?</Label>
                                                    </Col>
                                                    <Col md="6">
                                                        <Select
                                                            name="receive_information_via"
                                                            options={receiveInfoVia}
                                                            // maxMenuHeight="200px"
                                                            classNamePrefix="select2-selection"
                                                            className="form-control-lg p-0"
                                                            placeholder=""
                                                            onChange={selectedOption => {
                                                                let event = {
                                                                  target: {
                                                                    name: "receive_information_via",
                                                                    value: selectedOption,
                                                                  },
                                                                }
                                                                validation.handleChange(event)
                                                              }}
                                                              onBlur={() => {
                                                                validation.handleBlur({
                                                                  target: { name: "receive_information_via" },
                                                                })
                                                              }}
                                                              value={validation.values.receive_information_via || ""}
                                                              invalid={
                                                                validation.touched.receive_information_via &&
                                                                  validation.errors.receive_information_via
                                                                  ? true
                                                                  : false
                                                              }
                                                            />
                                                            {validation.touched.receive_information_via
                                                              && validation.errors.receive_information_via ? (
                                                              <small className='text-danger fs-13'>
                                                                {CONSTANTS.STR_REQUIRED_FIELD}
                                                              </small>
                                                            ) : null}
                                                    </Col>
                                                </Row>
                                                {/* receiveInfoVia ends */}
                                                {/* access_personal_information starts */}
                                                <Row className="my-2 mt-4 px-0">
                                                    <Col md='6' sm='12' className='fs-16 mb-2'>
                                                        <Label className="font-weight-semibold">Do you want access to your Personal Information?</Label>
                                                    </Col>
                                                    <Col md="4" sm='auto'>
                                                        <div className="btn-group gap-3">
                                                            <input type="radio" className="btn-check" name="access_personal_information" id="btnradio1" autoComplete="off" />
                                                            <label className="btn btn-outline-sfblue qf-radio-button" onClick={(e) => validation.setFieldValue("access_personal_information", true)} htmlFor="btnradio1">Yes</label>

                                                            <input type="radio" className="btn-check" name="access_personal_information" id="btnradio2" autoComplete="off" defaultChecked />
                                                            <label className="btn btn-outline-sfblue qf-radio-button" onClick={(e) => validation.setFieldValue("access_personal_information", false)} htmlFor="btnradio2">No</label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {/* access_personal_information ends */}
                                                {validation?.values?.access_personal_information &&
                                                <>
                                                {/* optionsPersonalInformation starts */}
                                                <Row className="my-2 mt-3 px-0">
                                                    <Col md='6' className='fs-16 mb-2'>
                                                        <Label className="font-weight-semibold">What type of Personal Information would you like to receive?</Label>
                                                    </Col>
                                                    <Col md="6" sm='12'>
                                                        <Select
                                                            name="type_of_info_like_to_receive"
                                                            options={optionsPersonalInformation}
                                                            // maxMenuHeight="200px"
                                                            classNamePrefix="select2-selection"
                                                            className="form-control-lg p-0"
                                                            placeholder=""
                                                            onChange={selectedOption => {
                                                                let event = {
                                                                  target: {
                                                                    name: "type_of_info_like_to_receive",
                                                                    value: selectedOption,
                                                                  },
                                                                }
                                                                validation.handleChange(event)
                                                              }}
                                                              onBlur={() => {
                                                                validation.handleBlur({
                                                                  target: { name: "type_of_info_like_to_receive" },
                                                                })
                                                              }}
                                                              value={validation.values.type_of_info_like_to_receive || ""}
                                                              invalid={
                                                                validation.touched.type_of_info_like_to_receive &&
                                                                  validation.errors.type_of_info_like_to_receive
                                                                  ? true
                                                                  : false
                                                              }
                                                            />
                                                            {validation.touched.type_of_info_like_to_receive
                                                              && validation.errors.type_of_info_like_to_receive ? (
                                                              <small className='text-danger fs-13'>
                                                                {CONSTANTS.STR_REQUIRED_FIELD}
                                                              </small>
                                                            ) : null}
                                                    </Col>
                                                </Row>
                                                {/* optionsPersonalInformation ends */}
                                                {/* personal_information_souces_type starts */}
                                                <Row className="my-2 mt-4 px-0">
                                                    <Col md='6' sm='12' className='fs-16 mb-2'>
                                                        <Label className="font-weight-semibold">Do you want to receive information about the types of sources of your Personal Information?</Label>
                                                    </Col>
                                                    <Col md="4" sm='auto'>
                                                        <div className="btn-group gap-3">
                                                            <input type="radio" className="btn-check" name="personal_information_souces_type" id="btnradio3" autoComplete="off" defaultChecked />
                                                            <label className="btn btn-outline-sfblue qf-radio-button" onClick={(e) => validation.setFieldValue("personal_information_souces_type", true)} htmlFor="btnradio3">Yes</label>

                                                            <input type="radio" className="btn-check" name="personal_information_souces_type" id="btnradio4" autoComplete="off" />
                                                            <label className="btn btn-outline-sfblue qf-radio-button" onClick={(e) => validation.setFieldValue("personal_information_souces_type", false)} htmlFor="btnradio4">No</label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {/* personal_information_souces_type ends */}
                                                {/* business_purpose_type starts */}
                                                <Row className="my-2 mt-3 px-0">
                                                    <Col md='6' className='fs-16 mb-2'>
                                                        <Label className="font-weight-semibold">Do you want to receive information about the business purposes for which we collected your Personal Information?</Label>
                                                    </Col>
                                                    <Col md="4" sm='auto'>
                                                        <div className="btn-group gap-3">
                                                            <input type="radio" className="btn-check" name="business_purpose_type" id="btnradio5" autoComplete="off" defaultChecked />
                                                            <label className="btn btn-outline-sfblue qf-radio-button" onClick={(e) => validation.setFieldValue("business_purpose_type", true)} htmlFor="btnradio5">Yes</label>

                                                            <input type="radio" className="btn-check" name="business_purpose_type" id="btnradio6" autoComplete="off" />
                                                            <label className="btn btn-outline-sfblue qf-radio-button" onClick={(e) => validation.setFieldValue("business_purpose_type", false)} htmlFor="btnradio6">No</label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {/* business_purpose_type ends */}
                                                {/* third_parties_information starts */}
                                                <Row className="my-2 mt-3 px-0">
                                                    <Col md='6' className='fs-16 mb-2'>
                                                        <Label className="font-weight-semibold">Do you want to receive information about the types of third parties to whom we disclosed your Personal Information in the past year?</Label>
                                                    </Col>
                                                    <Col md="4" sm='12'>
                                                        <div className="btn-group gap-3">
                                                            <input type="radio" className="btn-check" name="third_parties_information" id="btnradio7" autoComplete="off" defaultChecked />
                                                            <label className="btn btn-outline-sfblue qf-radio-button" onClick={(e) => validation.setFieldValue("third_parties_information", true)} htmlFor="btnradio7">Yes</label>

                                                            <input type="radio" className="btn-check" name="third_parties_information" id="btnradio8" autoComplete="off" />
                                                            <label className="btn btn-outline-sfblue qf-radio-button" onClick={(e) => validation.setFieldValue("third_parties_information", false)} htmlFor="btnradio8">No</label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {/* third_parties_information ends */}
                                                {/* business_purposes_for_disclose starts */}
                                                <Row className="my-2 mt-2 px-0">
                                                    <Col md='6' className='fs-16 mb-2'>
                                                        <Label className="font-weight-semibold">Do you want to receive information about the business purposes for which we disclosed your Personal Information in the past year?</Label>
                                                    </Col>
                                                    <Col md="4" sm='12'>
                                                        <div className="btn-group gap-3">
                                                            <input type="radio" className="btn-check" name="business_purposes_for_disclose" id="btnradio9" autoComplete="off" defaultChecked />
                                                            <label className="btn btn-outline-sfblue qf-radio-button" onClick={(e) => validation.setFieldValue("business_purposes_for_disclose", true)} htmlFor="btnradio9">Yes</label>

                                                            <input type="radio" className="btn-check" name="business_purposes_for_disclose" id="btnradio10" autoComplete="off" />
                                                            <label className="btn btn-outline-sfblue qf-radio-button" onClick={(e) => validation.setFieldValue("business_purposes_for_disclose", false)} htmlFor="btnradio10">No</label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {/* business_purposes_for_disclose ends */}
                                                </>
                                                }
                                                {/* delete_personal_info starts */}
                                                <Row className="my-2 mt-2 px-0">
                                                    <Col md='6' className='fs-16 mb-2'>
                                                        <Label className="font-weight-semibold">Do you want us to delete your Personal Information?</Label>
                                                    </Col>
                                                    <Col md="4" sm='12'>
                                                        <div className="btn-group gap-3">
                                                            <input type="radio" className="btn-check" name="delete_personal_info" id="btnradio11" autoComplete="off" />
                                                            <label className="btn btn-outline-sfblue qf-radio-button" onClick={(e) => validation.setFieldValue("delete_personal_info", true)} htmlFor="btnradio11">Yes</label>

                                                            <input type="radio" className="btn-check" name="delete_personal_info" id="btnradio12" autoComplete="off" defaultChecked />
                                                            <label className="btn btn-outline-sfblue qf-radio-button" onClick={(e) => validation.setFieldValue("delete_personal_info", false)} htmlFor="btnradio12">No</label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {/* delete_personal_info ends */}
                                                {/* opt_out_of_sale starts */}
                                                <Row className="my-2 mt-4 px-0">
                                                    <Col md='6' className='fs-16 mb-2'>
                                                        <Label className="font-weight-semibold">Do you want to opt-out of the sale of your Personal Information?</Label>
                                                    </Col>
                                                    <Col md="4" sm='12'>
                                                        <div className="btn-group gap-3">
                                                            <input type="radio" className="btn-check" name="opt_out_of_sale" id="btnradio13" autoComplete="off" />
                                                            <label className="btn btn-outline-sfblue qf-radio-button" onClick={(e) => validation.setFieldValue("opt_out_of_sale", true)} htmlFor="btnradio13">Yes</label>

                                                            <input type="radio" className="btn-check" name="opt_out_of_sale" id="btnradio14" autoComplete="off" defaultChecked />
                                                            <label className="btn btn-outline-sfblue qf-radio-button" onClick={(e) => validation.setFieldValue("opt_out_of_sale", false)} htmlFor="btnradio14">No</label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {/* opt_out_of_sale ends */}
                                                {/* authorized_agent starts */}
                                                <Row className="my-2 mt-4 px-0">
                                                    <Col md='6' className='fs-16 mb-2'>
                                                        <Label className="font-weight-semibold">Are you submitting this request as an authorized agent for the above consumer?</Label>
                                                    </Col>
                                                    <Col md="4" sm='12'>
                                                        <div className="btn-group gap-3">
                                                            <input type="radio" className="btn-check" name="authorized_agent" id="btnradio15" autoComplete="off" />
                                                            <label className="btn btn-outline-sfblue qf-radio-button" onClick={(e) => validation.setFieldValue("authorized_agent", true)} htmlFor="btnradio15">Yes</label>

                                                            <input type="radio" className="btn-check" name="authorized_agent" id="btnradio16" autoComplete="off" defaultChecked />
                                                            <label className="btn btn-outline-sfblue qf-radio-button" onClick={(e) => validation.setFieldValue("authorized_agent", false)} htmlFor="btnradio16">No</label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {/* authorized_agent ends */}
                                                {
                                                    validation?.values?.authorized_agent && <>
                                                    {/* agent_first_name starts */}
                                                    <Col md='6' className='d-flex flex-column fs-16 align-self-center my-2'>
                                                        <Label className="font-weight-semibold">Agent First Name<span className="text-danger">*</span></Label>
                                                        <Input
                                                            id="agent_first_name"
                                                            name="agent_first_name"
                                                            type='text'
                                                            className='form-control form-control-lg text-capitalize'
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.agent_first_name || ""}
                                                            invalid={
                                                            validation.touched.agent_first_name && validation.errors.agent_first_name
                                                                ? true
                                                                : false
                                                            }
                                                        />
                                                        {validation.touched.agent_first_name && validation.errors.agent_first_name ? (
                                                            <FormFeedback type="invalid">
                                                                {validation.errors.agent_first_name}
                                                            </FormFeedback>
                                                        ) : null}
                                                    </Col>
                                                    {/* agent_first_name ends */}
                                                    {/* agent_last_name starts */}
                                                    <Col md='6' className='d-flex flex-column fs-16 align-self-center mb-2'>
                                                        <Label className="font-weight-semibold">Agent Last Name<span className="text-danger">*</span></Label>
                                                        <Input
                                                            id="agent_last_name"
                                                            name="agent_last_name"
                                                            type='text'
                                                            className='form-control form-control-lg text-capitalize'
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.agent_last_name || ""}
                                                            invalid={
                                                            validation.touched.agent_last_name && validation.errors.agent_last_name
                                                                ? true
                                                                : false
                                                            }
                                                        />
                                                        {validation.touched.agent_last_name && validation.errors.agent_last_name ? (
                                                            <FormFeedback type="invalid">
                                                                {validation.errors.agent_last_name}
                                                            </FormFeedback>
                                                        ) : null}
                                                    </Col>
                                                    {/* agent_last_name ends */}
                                                    {/* agent_email starts */}
                                                    <Col md='6' className='d-flex flex-column fs-16 align-self-center mb-2'>
                                                        <Label className="font-weight-semibold">Agent Email Address<span className="text-danger">*</span></Label>

                                                        <Input
                                                            id="agent_email"
                                                            name="agent_email"
                                                            type='text'
                                                            className='form-control form-control-lg'
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.agent_email || ""}
                                                            invalid={
                                                            validation.touched.agent_email && validation.errors.agent_email
                                                                ? true
                                                                : false
                                                            }
                                                        />
                                                        {validation.touched.agent_email && validation.errors.agent_email ? (
                                                            <FormFeedback type="invalid">
                                                                {validation.errors.agent_email}
                                                            </FormFeedback>
                                                        ) : null}
                                                    </Col>
                                                    {/* agent_email ends */}
                                                    {/* agent_phone starts */}
                                                    <Col md='6' className='d-flex flex-column fs-16 align-self-center mb-2'>
                                                        <Label className="font-weight-semibold">Agent Phone Number<span className="text-danger">*</span></Label>
                                                        <NumberFormat
                                                            name="agent_phone"
                                                            format="###-###-####"
                                                            type="text"
                                                            mask="_"
                                                            className={validation.touched.agent_phone && validation.errors.agent_phone ? "is-invalid form-control form-control-lg" : "form-control form-control-lg"}
                                                            onValueChange={(values) => {
                                                                const { value } = values;
                                                                validation.setFieldValue('agent_phone', value);
                                                            }}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.agent_phone || ""}
                                                            invalid={validation.touched.agent_phone && validation.errors.agent_phone ? "true" : "false"}
                                                            aria-invalid={validation.touched.agent_phone && validation.errors.agent_phone ? "true" : "false"}
                                                        />
                                                        {validation.touched.agent_phone && validation.errors.agent_phone ? (
                                                        <small className="text-danger">
                                                            {validation.errors.agent_phone}
                                                        </small>
                                                        ) : null}
                                                    </Col>
                                                    {/* agent_phone ends */}
                                                    </>
                                                }
                                                <Row className='d-flex justify-content-center my-3'>
                                                    <Col md="auto" className='text-end'>
                                                        <Button type="submit"  className='w-auto btn btn-sfblue btn-lg text-center'>
                                                            Submit
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Row>
                                        </Form>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                </React.Fragment>
            </div>
    )
}

export default CCPAPolicyQf;